import AccountDetailsDialog from "../AccountDetailsDialog";

export const campaignMap = {
  accountDocuments: AccountDetailsDialog,
};
